module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_sp_1-3b7123fbc69a96631c4190824c3a1551.jpg";